import { render, staticRenderFns } from "./Loyalty.vue?vue&type=template&id=220e1015&scoped=true&"
import script from "./Loyalty.vue?vue&type=script&lang=js&"
export * from "./Loyalty.vue?vue&type=script&lang=js&"
import style0 from "./Loyalty.vue?vue&type=style&index=0&id=220e1015&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220e1015",
  null
  
)

export default component.exports